/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://o5myzpff4zguhlwt27qh6px234.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-central-1:b409362c-e557-48de-be7f-64819e38fde2",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_pL1ZwadUW",
    "aws_user_pools_web_client_id": "7vea3vfs92hsq99pqrki70hg10",
    "oauth": {},
    "aws_user_files_s3_bucket": "dryeyeportaluploads143234-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
